import { useEffect, useState } from 'react'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import ZendeskAPI from 'react-zendesk'

import { ID_ZENDESK } from 'components/Terminal/LayoutTerminal/constants'

declare global {
  interface Window {
    zE: (event: string, type: string, action: () => void) => void
  }
}

const Zendesk = () => {
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    if (window && window?.zE) {
      setOpen(false)
      window?.zE('messenger', 'close', () => {
        setOpen(false)
      })
    }
  }
  const handleOpen = () => {
    if (window && window?.zE) {
      setOpen(true)
      window?.zE('messenger', 'open', () => {
        setOpen(true)
      })
    }
  }

  useEffect(() => {
    if (window && window?.zE) {
      window?.zE('messenger:on', 'unreadMessages', () => {})
      window?.zE('messenger:on', 'close', () => {
        setOpen(false)
      })
      window?.zE('messenger:on', 'open', () => {
        setOpen(true)
      })
    }
  }, [])

  return (
    <div id="Zendesk-button">
      <ZendeskAPI defer zendeskKey={ID_ZENDESK} />
      <Tooltip title={'Ayuda'} className="button-support">
        <IconButton
          onClick={open ? handleClose : handleOpen}
          sx={{
            height: 40,
            width: 40,
            marginRight: 2,
            zIndex: 9,
            color: theme.palette.grey[100],
            '&:hover': {
              filter: 'brightness(0.9)'
            }
          }}
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
    </div>
  )
}

export default Zendesk
